/* DO NOT MODIFY. This is an autogenerated file. */
/* eslint-disable */
import * as React from "react"
import type { SVGProps } from "react"

export const SvgPaybillsProcessingEmpty = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "100%"}
    height={props.height || "100%"}
    fill="none"
    viewBox="0 0 150 150"
    data-name="SvgPaybillsProcessingEmpty"
    {...props}
  >
    {props.children}
    <g filter="url(#paybills-processing-empty_svg__a)">
      <circle cx={75} cy={75} r={67} fill="#fff" />
    </g>
    <g filter="url(#paybills-processing-empty_svg__b)">
      <circle cx={75} cy={75} r={63} fill="url(#paybills-processing-empty_svg__c)" />
    </g>
    <circle
      cx={75.5}
      cy={75.5}
      r={58.27}
      stroke="#339AA0"
      strokeDasharray="0.92 1.85"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.46}
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M93.517 88.89a1.672 1.672 0 0 1-2.916-.942 1.68 1.68 0 0 1 .35-1.211 18.555 18.555 0 0 0-.091-23.835 18.5 18.5 0 0 0-6.873-5.07.1.1 0 0 1-.062-.031 1.684 1.684 0 0 1-.944-2.19 1.685 1.685 0 0 1 2.184-.945l.12.052a21.8 21.8 0 0 1 8.14 5.985 21.9 21.9 0 0 1 4.578 9.019c.8 3.324.811 6.79.032 10.119a21.9 21.9 0 0 1-4.519 9.048M78.033 56.431l-11.542-.047h-.041a1.686 1.686 0 0 1-1.757-1.62 1.694 1.694 0 0 1 1.798-1.761h10.29c.522 0 .986 0 1.476.042a1.667 1.667 0 0 1 1.564 1.604v.193a1.68 1.68 0 0 1-1.122 1.48 1.7 1.7 0 0 1-.645.088zm8.038 6.5a1.66 1.66 0 0 1 .657 1.259c.025.411-.108.816-.37 1.134a1.683 1.683 0 0 1-2.356.256 11.68 11.68 0 0 0-7.22-2.482H57.62a1.675 1.675 0 0 1-1.537-1.06 1.686 1.686 0 0 1 .94-2.186c.204-.082.423-.122.644-.12h19.116a15.04 15.04 0 0 1 9.29 3.199m-.891 11.944a8.38 8.38 0 0 1-2.413 5.924 8.34 8.34 0 0 1-5.886 2.478H70.49a1.68 1.68 0 0 1-1.535-1.063 1.7 1.7 0 0 1-.118-.646v-6.662a1.694 1.694 0 0 1 1.668-1.703h.047a1.677 1.677 0 0 1 1.674 1.688v5.037h4.561a5.02 5.02 0 0 0 3.553-1.476 5.043 5.043 0 0 0 0-7.123 5.02 5.02 0 0 0-3.553-1.475h-23.13A1.677 1.677 0 0 1 52 68.15c.006-.446.188-.872.507-1.183a1.68 1.68 0 0 1 1.193-.478h23.098a8.38 8.38 0 0 1 5.912 2.447 8.42 8.42 0 0 1 2.47 5.913zm-22.296 1.719h-5.15a1.677 1.677 0 0 1-1.643-1.72 1.685 1.685 0 0 1 1.715-1.645h5.14a1.677 1.677 0 0 1 1.669 1.688v.031a1.694 1.694 0 0 1-1.731 1.61zm-8.93 3.334h8.992a1.68 1.68 0 0 1 1.7 1.656v.047a1.69 1.69 0 0 1-1.053 1.554 1.7 1.7 0 0 1-.647.123h-9.039a1.67 1.67 0 0 1-1.649-.956 1.687 1.687 0 0 1 .857-2.268c.207-.089.43-.135.657-.136zm3.696 6.708h19.147a11.7 11.7 0 0 0 8.278-3.412 11.75 11.75 0 0 0 3.457-8.276v-.052c0-1.335-.225-2.66-.667-3.919a1.69 1.69 0 0 1 1.05-2.089 1.68 1.68 0 0 1 2.124.97 15.15 15.15 0 0 1-1.914 13.761 15.1 15.1 0 0 1-5.38 4.693 15.05 15.05 0 0 1-6.932 1.69H57.609a1.68 1.68 0 0 1-1.538-1.059 1.686 1.686 0 0 1 .936-2.187c.205-.082.424-.122.644-.12m8.862 6.725h10.26a18.26 18.26 0 0 0 8.861-2.268c.237-.133.501-.21.772-.224a1.67 1.67 0 0 1 1.655 1.263 1.68 1.68 0 0 1-.852 1.903 21.7 21.7 0 0 1-10.447 2.675h-10.28a1.67 1.67 0 0 1-1.538-1.058 1.7 1.7 0 0 1-.12-.645 1.703 1.703 0 0 1 1.715-1.667z"
      clipRule="evenodd"
    />
    <defs>
      <filter
        id="paybills-processing-empty_svg__a"
        width={150}
        height={150}
        x={0}
        y={0}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={4} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_6319_10982" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_6319_10982" result="shape" />
      </filter>
      <filter
        id="paybills-processing-empty_svg__b"
        width={130}
        height={130}
        x={10}
        y={10}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_6319_10982" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_6319_10982" result="shape" />
      </filter>
      <linearGradient
        id="paybills-processing-empty_svg__c"
        x1={75}
        x2={75}
        y1={12}
        y2={141.718}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5DD6DE" />
        <stop offset={1} stopColor="#71F5BB" />
      </linearGradient>
    </defs>
  </svg>
)
